
import './promptwithicon.css'

import {CancelIconSmall} from'../customicons/CancelIconSmall'
import TextSnippetIcon from '@mui/icons-material/TextSnippet';

export const UploadedFile = ({filename, filesize, deleteFile}) => {
 
  const handleDeleteFile = () => {
    deleteFile()
  }

  return (
    <div className = 'flex-container'>
        <div className= 'uploadedFileBackground flex-container-top'>
          <TextSnippetIcon />

          <div style={{display: 'flex', flexDirection: 'column'}}>
            <div>{filename}</div>
              < div style={{fontSize: '0.8em', paddingLeft:'5px', color: 'maroon'}}>{filesize}</div>
          </div>     
          <CancelIconSmall   onClick={handleDeleteFile}/>
        </div>   
    </div>  
  )
}

UploadedFile.defaultProps = {
  filename: '',
  filesize:'',
}

export default UploadedFile



